import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useState } from 'react';

const DimensionField = ({
  label,
  shortLabel,
  field,
  value,
  onChange,
  onBlur,
  onFocus,
  unit,
  helpText,
  limitText,
  activeTooltip,
  setActiveTooltip,
  testId,
}) => {
  return (
    <div className="space-y-1 sm:space-y-2">
      <div className="flex items-center gap-1 sm:gap-2 relative">
        <Label className="text-xs sm:text-base font-semibold flex items-center gap-1 sm:gap-2">
          <span className="w-5 h-5 sm:w-8 sm:h-8 rounded-full bg-bush/10 flex items-center justify-center text-bush text-[10px] sm:text-sm font-bold">{shortLabel}</span>
          <span>{label}</span>
        </Label>
        {helpText && (
          <button className="sm:hidden w-4 h-4 rounded-full bg-gray-200 text-gray-500 text-[10px] font-semibold flex items-center justify-center" onClick={() => setActiveTooltip?.(activeTooltip === field ? null : field)}>i</button>
        )}
        {activeTooltip === field && helpText && (
          <div className="sm:hidden absolute left-0 bottom-full mb-2 z-50 w-48 p-2 bg-gray-900 text-white text-[11px] rounded-lg shadow-lg">
            <div className="absolute left-4 top-full w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-900"></div>
            {helpText}
          </div>
        )}
      </div>
      <div className="relative">
        <Input
          type="text"
          inputMode="decimal"
          placeholder="0"
          value={value}
          onChange={(e) => onChange(field, e.target.value)}
          onBlur={() => onBlur(field)}
          onFocus={(e) => {
            onFocus(field);
            // Move the caret to the end of the existing value when the input
            // gains focus (e.g. when a user taps the field on mobile), so they
            // can keep typing without first having to reposition the cursor.
            const el = e.target;
            const len = el.value.length;
            requestAnimationFrame(() => {
              try { el.setSelectionRange(len, len); } catch { /* type="number" inputs don't support selection range */ }
            });
          }}
          className="h-10 sm:h-14 text-base sm:text-xl font-semibold text-center bg-sand border-2 border-transparent focus:border-bush rounded-lg sm:rounded-xl pr-8 sm:pr-12 placeholder:text-gray-300"
          data-testid={testId || `${field}-input`}
        />
        <span className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-gray-400 font-medium text-xs sm:text-base">{unit}</span>
      </div>
      {helpText && <p className="hidden sm:block text-xs text-gray-500 mt-[5px]">{helpText}</p>}
      {limitText && <p className="sm:hidden text-[10px] text-gray-400">{limitText}</p>}
    </div>
  );
};

export default DimensionField;
